import { PropsWithChildren } from 'react';

import { Box } from '@twilio-paste/core/box';
import { Label, LabelProps } from '@twilio-paste/core/label';

import { InfoIcon } from '../InfoIcon';

interface InfoLabelProps {
  htmlFor: LabelProps['htmlFor'];
  infoText: string;
  required?: LabelProps['required'];
}

export function InfoLabel({
  htmlFor,
  infoText,
  children,
  required,
}: PropsWithChildren<InfoLabelProps>) {
  return (
    <Box display="flex" alignItems="flex-start" columnGap="space10">
      <Label htmlFor={htmlFor} required={required}>
        {children || ''}
      </Label>
      <InfoIcon tooltipText={infoText} />
    </Box>
  );
}
